import { render, staticRenderFns } from "./EnrollView.vue?vue&type=template&id=0ca6459e&"
import script from "./EnrollView.vue?vue&type=script&lang=js&"
export * from "./EnrollView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports